var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMentalHealthMedia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 63,
    height: 63,
    viewBox: "0 0 63 63",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "content",
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_276722",
    "data-name": "Path 276722",
    d: "M59,32.5H37A4.5,4.5,0,0,0,32.5,37V59A4.5,4.5,0,0,0,37,63.5H59A4.5,4.5,0,0,0,63.5,59V37A4.5,4.5,0,0,0,59,32.5Zm-18,5A3.5,3.5,0,1,1,37.5,41,3.5,3.5,0,0,1,41,37.5ZM59.171,56.938a1.5,1.5,0,0,1-2.108.233L48,49.921l-9.062,7.25a1.5,1.5,0,1,1-1.875-2.342l10-8a1.5,1.5,0,0,1,1.875,0l10,8a1.5,1.5,0,0,1,.233,2.108Z",
    fill: "#fd930d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276723",
    "data-name": "Path 276723",
    d: "M59,.5H5A4.5,4.5,0,0,0,.5,5V59A4.5,4.5,0,0,0,5,63.5H28.525a1.5,1.5,0,1,0,0-3H5A1.5,1.5,0,0,1,3.5,59V33.5H26a1.5,1.5,0,0,0,0-3H3.5V5A1.5,1.5,0,0,1,5,3.5H30.5V26a1.5,1.5,0,0,0,3,0V3.5H59A1.5,1.5,0,0,1,60.5,5V28.525a1.5,1.5,0,0,0,3,0V5A4.5,4.5,0,0,0,59,.5Z",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276724",
    "data-name": "Path 276724",
    d: "M16.474,8.6l-6.7,2.513A3.515,3.515,0,0,0,7.5,14.386v5.229a3.514,3.514,0,0,0,2.271,3.276l6.7,2.514A1.5,1.5,0,0,0,18.5,24V10a1.5,1.5,0,0,0-2.026-1.4ZM15.5,21.835l-4.677-1.754a.5.5,0,0,1-.323-.467V14.386a.5.5,0,0,1,.324-.468L15.5,12.165Z",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276725",
    "data-name": "Path 276725",
    d: "M25,15.5H22a1.5,1.5,0,0,0,0,3h3a1.5,1.5,0,1,0,0-3Z",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276726",
    "data-name": "Path 276726",
    d: "M22.671,13.342l3-1.5a1.5,1.5,0,1,0-1.342-2.684l-3,1.5a1.5,1.5,0,1,0,1.342,2.684Z",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276727",
    "data-name": "Path 276727",
    d: "M22.671,20.658a1.5,1.5,0,0,0-1.342,2.684l3,1.5a1.5,1.5,0,1,0,1.342-2.684Z",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276728",
    "data-name": "Path 276728",
    d: "M42.671,23.342l12-6a1.5,1.5,0,0,0,0-2.684l-12-6A1.5,1.5,0,0,0,40.5,10V22a1.5,1.5,0,0,0,2.171,1.342ZM43.5,12.427,50.646,16,43.5,19.573Z",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276729",
    "data-name": "Path 276729",
    d: "M26,38.5H10a1.5,1.5,0,0,0,0,3H26a1.5,1.5,0,0,0,0-3Z",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276730",
    "data-name": "Path 276730",
    d: "M27.5,46A1.5,1.5,0,0,0,26,44.5H10a1.5,1.5,0,0,0,0,3H26A1.5,1.5,0,0,0,27.5,46Z",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276731",
    "data-name": "Path 276731",
    d: "M10,50.5a1.5,1.5,0,0,0,0,3h8a1.5,1.5,0,0,0,0-3Z",
    fill: "#515255"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMentalHealthMedia);
export default __webpack_public_path__ + "static/media/Mental_Health_Media.95ff96059b214d344d078e7ad155c267.svg";
export { ForwardRef as ReactComponent };